import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import { UserContext } from '~/components/providers/UserProvider';
import { useLocationKey } from '~/hooks/useLocationKey';
import { getContests } from '~/services/contests/contests.service.api';
import { STALE_TIME } from '~/domains/contest/constants/query';
import { PUSHER_SEARCH_ENDPOINT } from '~/domains/pusher/constants';
import { usePusherFetch } from '~/domains/pusher/hooks/usePusherFetch';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';

const FOLLOWED_CHANNELS_PAYLOAD = {
  limit: 20,
  offset: 0,
  filter: { followedChannels: true },
  includeFull: false,
};

export const useFollowedChannelsContests = (enabled = true) => {
  const { user } = useContext(UserContext);
  const { locationKey, isLocationReady } = useLocationKey();
  const { fetchRows, isReady: isPusherReady } = usePusherFetch<Contest>({
    enabled,
    endpoint: PUSHER_SEARCH_ENDPOINT,
  });

  const { data, isLoading, isInitialLoading, error, refetch } = useQuery({
    queryKey: ['followed-channels-contests', user?.id, locationKey],
    queryFn: () => fetchRows((headers) => getContests(FOLLOWED_CHANNELS_PAYLOAD, headers)),
    enabled: enabled && isLocationReady && isPusherReady,
    staleTime: STALE_TIME,
    keepPreviousData: true,
  });

  return {
    contests: data ?? [],
    isLoading,
    isInitialLoading,
    error,
    refetch,
  };
};
